import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Product from '../views/product.vue'
import ProductDetail from '../views/productDatails.vue'
import CultureAndValues from '../views/cultureAndValues.vue'
import OurBusiness from '../views/ourBusiness.vue'
import ContactUs from '../views/contactUs.vue'
import SecurityCheck from '../views/SecurityCheck.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import Disclaimer from '../views/Disclaimer.vue'
import FAQ from '../views/FAQ.vue'
import ManualsGuide from '../views/ManualsGuide.vue'
import NewsPressReleases from '../views/NewsPressReleases.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/product',
    name: 'Product',
    component: Product
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail
  },
  {
    path: '/cultureAndValues',
    name: 'CultureAndValues',
    component: CultureAndValues
  },
  {
    path: '/ourBusiness',
    name: 'OurBusiness',
    component: OurBusiness
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: ContactUs
  },
  {
    path: '/securityCheck',
    name: 'SecurityCheck',
    component: SecurityCheck
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: Disclaimer
  },
  {
    path: '/manualsGuide',
    name: 'ManualsGuide',
    component: ManualsGuide
  },
  {
    path: '/newsPressReleases',
    name: 'NewsPressReleases',
    component: NewsPressReleases
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 处理锚点跳转, 如请求路径里带有 #scrollToTop 则滚动到对应位置
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth', // 平滑滚动
      }
    }
    // 其他情况返回顶部
    return { top: 0 }
  }
})

export default router